import Vue, { getCurrentInstance } from 'vue';
import Vuetify from 'vuetify/lib';
import { merge } from 'lodash';
import '@mdi/font/css/materialdesignicons.css';
import { vuetifyConfig } from '@girder/components/src';
Vue.use(Vuetify);
function getVuetify(config) {
    const theme = {
        dark: true,
        options: {
            customProperties: true,
        },
        themes: {
            dark: {
                accentBackground: '#2c7596',
                accent: '#fbd178',
                accentActive: '#fde4b0',
                accentHover: '#fcde9c',
                primary: '#f1806a',
                primaryActive: '#f7c0b4',
                primaryHover: '#f5a08f',
                secondary: '#84b7c2',
                secondaryActive: '#bbd7dd',
                secondaryHover: '#9fc7d0',
                error: '#9a3a36',
                info: '#3e5e72',
                success: '#3a614e',
                warning: '#997a4d',
                background: '#2c2827',
                surface: '#1e1c1b',
                'surface-alt': '#121010',
                'border-1': '#48423d',
                'border-2': '#635f5d',
                'text-high': '#231812',
                'text-medium': '#bbb5b1',
                'text-low': '#867b73',
                'feedback-error': '#f9dad7',
                'feedback-info': '#d6eef8',
                'feedback-success': '#cfefda',
                'feedback-warning': '#fceccb',
            },
        },
    };
    const appVuetifyConfig = merge(vuetifyConfig, config, { theme });
    return new Vuetify(appVuetifyConfig);
}
export default getVuetify;
export const useVuetify = () => {
    const vm = getCurrentInstance();
    return vm?.proxy?.$vuetify || undefined;
};
